import {action, computed, observable, reaction, runInAction} from 'mobx';

import looperStore from '../containers/create/looper/store';
import actionStore from '../stores/ActionStore';
import {getAttachmentUrl} from "../utils/commonUtility";
import device from 'current-device';
import debounce from 'lodash/debounce';
import isNumber from 'lodash/isNumber';
import request from "../utils/request";
import {isIos, isMobile, isSafari} from "../utils/screenUtility";
import audioManager from '../utils/AudioManager'
import wizardStore from '../containers/studio/store';


class NotationViewerStore {
    @observable track = null;
    @observable notation = {numPages: 0, annotations: {}};
    @observable isLoaded = false;
    @observable duringDrag = false;
    @observable error = false;
    @observable scale = 1;
    @observable svg = '';
    @observable stepIndex = 0;
    @observable playback = [];
    @observable minTimeDelta = Number.MAX_SAFE_INTEGER;
    @observable notationRef = null;
    @observable cursorRef = null;
    @observable playing = false;
    @observable scrollLeft = 0;
    @observable horizontal = false;
    @observable parentTop = 0;
    xmlLoaded = false;
    scaleSetByUser = false;


    reminder = 0;
    interval = null;
    internalTimeout = null;
    speed = 1;


    constructor() {
        reaction(
            () => this.stepIndex,
            (stepIndex) => {
                if (!this.cursorRef) return;
                setTimeout(() => {
                    if (!this.xmlLoaded || stepIndex === this.playback.length) {
                        return;
                    }

                    if (!looperStore.isLooperPlaying && this.horizontal) {
                        this.horizontalSeekTo(stepIndex);
                    } else if (!this.horizontal && (!isSafari() && !isIos())) {
                        this.cursorRef.scrollIntoView({behavior: "auto", block: "center", inline: "start"});
                    } else {
                        this.cursorRef.scrollIntoViewIfNeeded(true);
                    }
                }, 0);
            },
            {});

        reaction(
            () => this.notationRef,
            (ref) => {
                if (!ref || !this.xmlLoaded) {
                    return;
                }

                if (this.horizontal && this.notationRef.firstChild) {
                    this.notationRef.firstChild.style['margin-right'] = window.innerWidth - this.firstPosition.left;
                }

                if (ref && ref.parentElement) {
                    runInAction(() => {
                        this.parentTop = ref.parentElement.getBoundingClientRect().y;
                    });
                }

                const dragTolerance = 100;
                let drag = false;
                let dragData = {};
                ref.addEventListener('mousedown', (e) => {
                    if (!this.xmlLoaded) {
                        return;
                    }
                    // e.preventDefault();
                    drag = true;
                    // console.log('y: ' + e.offsetY );//+ ' scrollTop: ' + ref.parentElement.scrollTop);
                    const startX = e.offsetX;
                    const startY = e.offsetY;
                    dragData.startX = startX;
                    dragData.startY = startY;

                    this.closestToStartIndex = this.getClosestIndex(startX, startY);
                    // console.log("Closets index: " +  this.closestToStartIndex);
                }, false);
                ref.addEventListener('mouseup', (e) => {
                    // e.preventDefault();
                    if (!this.xmlLoaded || this.horizontal) {
                        return;
                    }

                    if (!dragData.endX || this.dist(dragData.startX, dragData.startY, dragData.endX, dragData.endY) < dragTolerance) {
                        if (this.closestToStartIndex !== undefined) {
                            runInAction(() => {
                                this.stepIndex = this.closestToStartIndex;
                            });

                            looperStore.looperTracksSeekTo(this.getIndexTime(this.closestToStartIndex, true), true);
                            this.clearSelection();
                            looperStore.setPlaySlice(null, null, null, null, null, true, true);
                        }
                    } else {
                        if (this.closestToEndIndex !== undefined) {
                            this.drawSelection(Math.min(this.closestToStartIndex, this.closestToEndIndex), Math.max(this.closestToStartIndex, this.closestToEndIndex));
                            const from = this.getIndexTime(this.closestToStartIndex, true);
                            const to = this.getIndexTime(this.closestToEndIndex + 1, true);

                            looperStore.setPlaySlice(Math.min(from, to), Math.max(from, to), 6, 0, [], true, true);
                        }
                    }
                    dragData = {};
                    drag = false;
                }, false);

                ref.addEventListener('mousemove', (e) => {
                    // e.preventDefault();
                    if (!this.xmlLoaded || this.horizontal) {
                        return;
                    }
                    if (drag) {
                        const endX = e.offsetX;// + ref.parentElement.scrollLeft;
                        const endY = e.offsetY;// + ref.parentElement.scrollTop;
                        dragData.endX = endX;
                        dragData.endY = endY;
                        if (this.dist(dragData.startX, dragData.startY, dragData.endX, dragData.endY) < dragTolerance) {
                            return;
                        }
                        this.closestToEndIndex = this.getClosestIndex(endX, endY);
                        const startIndex = Math.min(this.closestToEndIndex, this.closestToStartIndex);
                        const endIndex = Math.max(this.closestToEndIndex, this.closestToStartIndex);
                        this.drawSelection(startIndex, endIndex);
                    }
                }, false)

                ref.addEventListener('touchmove', (e) => {
                    runInAction(() => {
                        if (this.horizontal) {
                            const startX = e.target.parentElement.parentElement.scrollLeft + this.firstPosition.left + 15;
                            const startY = e.target.parentElement.parentElement.scrollTop + this.firstPosition.top;
                            this.closestToStartIndex = this.getClosestIndex(startX, startY);
                            looperStore.looperTracksSeekTo(this.getIndexTime(this.closestToStartIndex, true), true);
                        }
                        // console.log("Closets index: " +  this.closestToStartIndex);
                    })
                });
            },
            {}
        )
    }

    horizontalSeekTo = (stepIndex) => {
        // if (stepIndex > 0) {
        //     const time1 = this.tickToTime(this.playback[stepIndex].tick, stepIndex);
        //     const time2 = this.tickToTime(this.playback[stepIndex - 1].tick, stepIndex - 1);
        //     let time = time1 - time2;
        //     const left = this.getPosition(stepIndex).left;
        //     const prevLeft = this.getPosition(stepIndex - 1).left;
        //     const moveTo = left + (left - prevLeft) / ((time * 1000) / this.reminder);
        //     this.notationRef.parentElement.scrollTo(Math.round(moveTo), 0);
        // }
        const left = this.getPosition(stepIndex).left - this.firstPosition.left;
        this.notationRef.parentElement.scrollTo(Math.round(left), 0);
    }


    getPosition = (index) => {
        let x, y, top, left, height, width = 0;
        if (index < 0) {
            index = 0;
        }
        try {
            if (this.xmlLoaded && !this.error && this.playback && this.playback.length > 0) {
                let pos = this.playback[index].pos;
                if (!pos.height && index > 0) {
                    pos = this.playback[index - 1].pos;
                }
                x = pos.x;
                y = pos.y;
                top = y * 10 * this.scale;
                if (this.horizontal && this.notationRef) {
                    top += this.parentTop;
                }
                left = (x - 1.5) * 10 * this.scale;
                height = pos.height * 10.0 * this.scale;
                width = 30 * this.scale;
            }
        } catch (err) {
            console.log(err);
        }

        return {x, y, top, left, height, width};
    };

    @computed
    get firstPosition() {
        return this.getPosition(0)
    }

    @computed
    get cursorPosition() {
        if (this.horizontal) {
            return this.firstPosition;
        } else {
            return this.getPosition(this.stepIndex);
        }
    }


    @action clear = () => {
        this.svg = '';
        this.playback = [];
        this.stepIndex = 0;
        this.notation = {};
        this.isLoaded = false;
        this.error = false;
        this.scale = 1;
        this.notationRef = undefined;
        this.cursorRef = undefined;
        this.horizontal = false;
        this.xmlLoaded = false;
    };

    @action setCursorRef = (cursorRef) => {
        this.cursorRef = cursorRef;
    };

    @action setNotationRef = (notationRef) => {
        this.notationRef = notationRef;
    };

    @action setTrack = (track) => {
        this.track = track;
    };

    @action redraw = async (notation, silent = false) => {
        if (!silent) this.isLoaded = false;
        if (!this.scaleSetByUser) {
            this.scale = isMobile() ? 0.75 : 1;
        }
        try {
            const {svg, playback} = await request(`osmd/load?url=${getAttachmentUrl(this.notation)}&width=${window.innerWidth}&zoom=${this.scale}&horizontal=${this.horizontal}`, {}, true);
            if (notation && this.notation && this.notation.id !== notation.id) {
                await this.setNotation(this.notation);
                return;
            }
            runInAction(() => {
                this.svg = svg;
                this.playback = playback.filter(step => !!step.pos?.x);
                this.isLoaded = true;
                if (this.playback && this.playback.length > 0) {
                    for (let i = 1; i < this.playback.length; i++) {
                        this.minTimeDelta = Math.min(this.minTimeDelta, this.playback[i].totalTime - this.playback[i - 1].totalTime)
                    }
                    this.init();
                } else {
                    console.log('playback data not found');
                    if (!silent) this.error = true;
                }
                this.xmlLoaded = true;
            })
        } catch (err) {
            console.log(err);
            if (!silent) {
                runInAction(() => {
                    this.error = true;
                });
            }
        }
    };

    @action setNotationRotation = (rotate) => {
        this.notation = {...this.notation, rotate};
    };

    @action setCanvasToNotation = (notation) => {
        this.notation = {...notation};
    };

    @action setNotation = async (notation) => {
        // this.isLoaded = false;
        this.error = false;
        this.xmlLoaded = false;
        if (!notation) {
            return;
        }
        if (this.notation && notation && this.notation.id === notation.id && this.notation.annotations === notation.annotations) {
            this.xmlLoaded = this.isXmlType(notation.type, notation.name);
            return;
        }
        this.notation = notation;
        if (this.isXmlType(notation.type, notation.name)) {
            this.scaleSetByUser = false;
            this.xmlLoaded = true;
            this.setTrack(looperStore.leaderTrack);
            await this.redraw(notation);
        } else {
            this.notation.numPages = 1;
            if (!this.scaleSetByUser) {
                this.scale = 1;
            }
        }

        if (this.listner) {
            this.listner();
        }
        this.listner = reaction(
            () => wizardStore.fullScreenMode,
            () => {
                setTimeout(() => {
                    runInAction(() => {
                        if (this.notationRef && this.notationRef.parentElement) {
                            this.parentTop = this.notationRef.parentElement.getBoundingClientRect().y;
                            // console.log('settings: ' + this.parentTop);
                        }
                    })
                }, 0);
            }
        );
    };

    @computed
    get pitchChanged() {
        return looperStore.pitch !== 0;
    }

    @computed
    get stemEdited() {
        return this.track && actionStore.getByTrackId(this.track.id, false).length > 0;
    }

    removeAllElements = (className) => {
        let elements = document.getElementsByClassName(className);
        while (elements.length > 0) {
            elements[0].parentNode.removeChild(elements[0]);
        }
    };

    clearSelection = () => {
        // this.selectionCtx.clearRect(0, 0, this.selectionElement.width, this.selectionElement.height);
        if (this.leftSelectionElement) {
            this.leftSelectionElement.style.display = "none";
        }
        if (this.rightSelectionElement) {
            this.rightSelectionElement.style.display = "none";
        }
        this.removeAllElements('selection');
    };

    drawSelection = (startIndex, endIndex) => {
        if (!this.notationRef || !this.notationRef.firstChild) {
            return;
        }
        const svg = this.notationRef.firstChild;
        this.clearSelection();
        for (let i = startIndex; i <= endIndex; i++) {
            const x = (this.playback[i].pos.x - 1.5) * 10.0;
            let w;
            if (i + 1 === this.playback.length) {
                w = this.playback[i].pos.width * 10.0;
            } else {
                w = (this.playback[i + 1].pos.x - 1.5) * 10.0 - x;
            }
            if (w < 0) {
                w = 3 * 10.0 * this.scale;
            }
            const y = this.playback[i].pos.y * 10.0;
            const h = this.playback[i].pos.height * 10.0;
            let rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            rect.setAttributeNS(null, 'class', 'selection');
            rect.setAttributeNS(null, 'width', w);
            rect.setAttributeNS(null, 'height', h);
            rect.setAttributeNS(null, 'x', x);
            rect.setAttributeNS(null, 'y', y);
            rect.setAttributeNS(null, 'fill', 'rgba(0,0,0,0.3)');
            svg.appendChild(rect);
            if (i === startIndex) {
                this.leftSelectionElement = document.createElement("div");
                this.leftSelectionElement.classList.add("left-selection");

                this.notationRef.appendChild(this.leftSelectionElement);

                this.leftSelectionElement.style.left = x * this.scale + "px";
                this.leftSelectionElement.style.top = (y - 50) * this.scale + "px";
                this.leftSelectionElement.style.height = (h + 50) * this.scale + "px";
                this.leftSelectionElement.style.display = "";
            }

            if (i === endIndex) {
                this.rightSelectionElement = document.createElement("div");
                this.rightSelectionElement.classList.add("right-selection");
                this.notationRef.parentElement.appendChild(this.rightSelectionElement);

                this.rightSelectionElement.style.left = (x + w) * this.scale + "px";
                this.rightSelectionElement.style.top = (y - 50) * this.scale + "px";
                this.rightSelectionElement.style.height = (h + 50) * this.scale + "px";
                this.rightSelectionElement.style.display = "";
            }
        }
    };


    @action init = () => {
        this.setSpeed(this.track.bpm / this.track.originalBPM, looperStore.bpm);
        if (isNumber(looperStore.playSlice.start) && isNumber(looperStore.playSlice.end)) {
            setTimeout(() => {
                // console.log(looperStore.playSlice.end);
                this.setSelection(looperStore.playSlice.start, looperStore.playSlice.end);
            }, 0);
        }
        // this.seek(audioManager.getCurrentTime(this.track.playerID));
        setTimeout(() => {
            if (this.horizontal) {
                this.horizontalSeekTo(this.stepIndex);
            } else if (this.cursorRef) {
                if (this.cursorRef.scrollIntoViewIfNeeded) {
                    this.cursorRef.scrollIntoViewIfNeeded(true);
                } else {
                    this.cursorRef.scrollIntoView(true);
                }
            }
        }, 0);
        looperStore.playPauseIfWasPlaying();
    };

    dist = (x1, y1, x2, y2) => {
        return Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2);
    };

    getClosestIndex = (x, y) => {
        let closestTo = Number.MAX_VALUE;
        let closeToIndex = undefined;

        for (let i = 0; i < this.playback.length; i++) {
            if (!this.playback[i].pos) {
                continue;
            }
            const cx = (this.playback[i].pos.x + 1.5) * 10.0 * this.scale;
            const cy = (this.playback[i].pos.y + this.playback[i].pos.height / 2) * 10.0 * this.scale;
            const distance = this.dist(cx, cy, x, y);

            if (distance < closestTo) {
                closestTo = distance;
                closeToIndex = i;
            }
        }
        return closeToIndex;
    };

    getIndexTime = (index, inclusive = false) => {
        if (index === 0) {
            return 0;
        }
        const i = inclusive ? index - 1 : index;
        if (i < 0 || i > this.playback.length) {
            return 0;
        }
        return this.adjustTimeWithSpeed(this.playback[i]);
    };

    adjustTimeWithSpeed = (tick) => {
        let speed = this.speed;
        if (tick.isDefaultBpm) {
            speed = looperStore.bpm / tick.bpm;
        }
        return Math.round(tick.totalTime / speed * 1e5) / 1e5;
    };

    @action play = () => {
        // console.log('play called');
        clearTimeout(this.interval);
        clearTimeout(this.internalTimeout);

        if (!this.xmlLoaded || !this.playback || this.stepIndex === this.playback.length) {
            // this.stepIndex = 0;
            return;
        }

        if (this.track) {
            this.seek(audioManager.getCurrentTime(this.track.playerID));
        }
        // console.log(this.reminder);
        const tick = this.playback[this.stepIndex];
        let tickDelay = this.adjustTimeWithSpeed(tick) * 1000;
        // Math.round(this.tickToTime(this.minTick / this.speed / 8, 0) * 1000)
        const baseTickInterval = Math.max(10, Math.round(this.minTimeDelta / this.speed / 8) * 1000);
        // console.log(baseTickInterval);
        // console.log(this.minTick);
        let t1 = tickDelay;
        if (this.stepIndex === 0) {
            t1 = baseTickInterval;
        } else {
            t1 = tickDelay - baseTickInterval;
        }
        if (this.reminder > 0) {
            t1 = tickDelay - this.reminder * 1000;
            this.reminder = 0;
        }
        let drift = 0;
        let lastTick = Date.now();
        let stepIndex = this.stepIndex;
        this.playing = true;
        // let delta = this.notationRef.parentElement.scrollLeft;
        this.interval = setInterval(() => {
            // if (this.horizontal && stepIndex > 0) {
            //     const time1 = this.tickToTime(this.playback[stepIndex].tick, stepIndex);
            //     const time2 = this.tickToTime(this.playback[stepIndex - 1].tick, stepIndex - 1);
            //     let time = time1 - time2;
            //     const left = this.getPosition(stepIndex).left;
            //     const prevLeft = this.getPosition(stepIndex - 1).left;
            //     delta += (left - prevLeft) / ((time * 1000) / baseTickInterval);
            //     this.notationRef.parentElement.scrollTo(Math.round(delta), 0);
            // }
            const t2 = Date.now();
            if (t1 + baseTickInterval > tickDelay) {
                drift = tickDelay - t1;
                this.internalTimeout = setTimeout(() => {
                    runInAction(() => {
                        this.stepIndex++;
                        if (this.horizontal) {
                            const left = this.getPosition(this.stepIndex).left - this.firstPosition.left;
                            this.notationRef.parentElement.scrollTo(Math.round(left), 0);
                        }
                    });
                }, drift);
                // this.stepIndex++;
                stepIndex++;

                if (!this.playback || this.playback.length === 0 || stepIndex >= this.playback.length) {
                    clearInterval(this.interval);
                    clearTimeout(this.internalTimeout);
                    return;
                }
                tickDelay = this.adjustTimeWithSpeed(this.playback[stepIndex]) * 1000;
            }
            t1 += t2 - lastTick;
            lastTick = t2;
        }, baseTickInterval);
    };

    @action pause = () => {
        // console.log('pause called');
        clearTimeout(this.interval);
        clearTimeout(this.internalTimeout);
        this.playing = false;
    };

    @action seek = (time) => {
        if (!this.playback || this.playback.length === 0) {
            return;
        }
        let stepIndex = 0;
        let reminder = 0;
        let pctToNext = 0;
        let cursorTime = 0;
        // let prevCursorTime: number = 0;
        for (let i = 0; i < this.playback.length && time > 0; i++) {
            cursorTime = this.adjustTimeWithSpeed(this.playback[i]);
            if (cursorTime > time) {
                reminder = cursorTime - time;
                // console.log(this.reminder);
                break;
            }
            // prevCursorTime = cursorTime;
            stepIndex++;
        }
        // console.log('stepIndex: ' + stepIndex);
        this.stepIndex = Math.min(stepIndex, this.playback.length - 1);
        this.reminder = reminder;
        clearTimeout(this.interval);
        clearTimeout(this.internalTimeout);
    };

    setSpeed = (speed, bpm) => {
        // console.log('set speed osmd');
        // this.postMessage({type: 'speed', value: speed, bpm: bpm});
        this.speed = speed;
        this.reminder /= speed;
        // this.bpm = bpm;
    };

    setSelection = (from, to) => {
        let cursorTime = 0;
        if (from === null && to === null) {
            this.clearSelection();
            this.closestToStartIndex = undefined;
            this.closestToEndIndex = undefined;
            return;
        }
        from = Math.ceil(from * 1e5) / 1e5;
        to = Math.ceil(to * 1e5) / 1e5;

        let fromIndex = from === 0 ? 0 : undefined;
        let toIndex = undefined;
        for (let i = 0; i < this.playback.length; i++) {
            cursorTime = this.adjustTimeWithSpeed(this.playback[i]);
            if (fromIndex === undefined && cursorTime > from) {
                fromIndex = i;
            }
            if (cursorTime > to) {
                toIndex = i - 1;
                break;
            }
        }
        if (toIndex === undefined) {
            toIndex = this.playback.length - 1;
        }
        this.closestToStartIndex = Math.min(fromIndex || 0, toIndex);
        this.closestToEndIndex = Math.max(fromIndex || 0, toIndex);
        // log.debug("selection: " + fromIndex + ", toIndex:" + toIndex);
        this.drawSelection(this.closestToStartIndex, this.closestToEndIndex);
    };

    zoom = debounce((z) => {
        // console.log('set zoom osmd: ' + zoom);
        // this.postMessage({type: 'zoom', value: z});
        if (this.xmlLoaded) {
            this.redraw();
        }
    }, 250);

    @action setZoom = (z) => {
        this.scale = z;
        this.scaleSetByUser = true;
        this.zoom(z);
    };

    @action setHorizontalView = (value) => {
        this.horizontal = value;
        if (this.xmlLoaded) {
            this.redraw();
        }
        // this.postMessage({type: 'horizontal', value: value});
    };

    isXml() {
        return this.isXmlType(this.notation.name, this.notation.type);
    }

    isXmlType(name, type) {
        let res = false;
        if (type) {
            res = type.indexOf('xml') >= 0 || type.indexOf('mxl') >= 0;
        }
        if (name) {
            res = res || name.indexOf('mxl') >= 0 || name.indexOf('xml') >= 0;
        }
        return res;
    }

    setAnnotationRefreshHandler = (annotationRefreshHandler) => {
        this.annotationRefreshHandler = annotationRefreshHandler;
    }

    refreshAnnoations = () => {
        if (this.annotationRefreshHandler) {
            this.annotationRefreshHandler();
        }
    }
}

const notationViewerStore = new NotationViewerStore();
export default notationViewerStore;
